




































import { defineComponent } from '@vue/composition-api';
import ALink from '../a-link/a-link.vue';

// 表单中的蓝底提示语框

const name = 'ttam-tip-box';

export default defineComponent({
  name,
  components: {
    ALink,
  },
  props: {
    type: {
      type: String,
      default: 'info',
    },
    closable: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    linkUrl: {
      type: String,
      default: '',
    },
    linkText: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    function handleLinkClick() {
      emit('link-click');
    }

    return {
      handleLinkClick,
      name,
    };
  },
});
